import React from 'react'
import { get } from 'microcosm'
import RA from 'ra-config'
import * as placeholder from 'lib/config/placeholder'

class ReturnsText extends React.Component {
  render() {
    let { type } = this.props
    const methodText = get(RA, ['content', type, 'methodText'], '')
    let text = placeholder.replace(methodText)

    return (
      <div className="chart-container">
        <div className="chart-container__menu -fill">
          <h3 className="chart-container__heading">
            How do we form expected returns?
          </h3>
        </div>
        <div className="chart-container__content">
          <p dangerouslySetInnerHTML={{ __html: text }} />
        </div>
      </div>
    )
  }
}

export default ReturnsText



// WEBPACK FOOTER //
// ./src/components/returns-text.js